export class User {
    constructor(
        public name?: string,
        public password?: string,
        public nick?: string,
        public active?: boolean,
        public children?: User[],
        public isChildUser?: boolean,
        /** Permission to control Scheduler master switch (can_control_scheduler_switch). */
        public canControlSchedulerSwitch?: boolean,
        /** Permission to edit weekly schedule (future use). */
        public canEditWeeklyScheduler?: boolean,
        /** Permission to edit special dates schedule (future use). */
        public canEditSpecialDates?: boolean,
    ) {
    }

    public init(): User {
        this.name = "";
        this.password = "";
        this.nick = "";
        this.active = false;
        this.children = [];
        this.isChildUser = false;
        this.canControlSchedulerSwitch = false;
        this.canEditWeeklyScheduler = false;
        this.canEditSpecialDates = false;

        return this;
    }
}